import { Component, OnInit, HostListener, Output, EventEmitter, Renderer2, Inject, DOCUMENT } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { CommonserviceService } from './Service/CommonService/commonservice.service';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { AuthService } from './Service/auth/auth.service';
import { SocketServiceService } from './Service/Socket/socket-service.service';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { BnNgIdleService } from 'bn-ng-idle';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit {
  title = ' | Cryptocurrency Exchange | KoinNation';
  ipdata: any = {};
  IP: any = {};
  block_page: Boolean = false; ipDetails: any = {};
  theme: string;
  countrycode: any = {};
  @Output() themeCng = new EventEmitter<string>();


  constructor(private router: Router, private service: CommonserviceService, private authService: AuthService,
    private http: HttpClient, private socket: SocketServiceService, private toastr: ToastrService, private titleService: Title, private metaService: Meta, private bnIdle: BnNgIdleService, private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {
    this.bnIdle.startWatching(72000).subscribe((res: any) => {
      if (res) {
        this.authService.clearAuthData()
        this.router.navigate(['/login'])
        this.toastr.error("Your Session Expired")
      }
    });

    this.http.get<{ ip: string }>('https://api.ipify.org/?format=json').subscribe(data => {
      this.ipdata = data;
      const datas = {
        ipaddress: this.ipdata.ip
      };
      localStorage.setItem('ip', this.ipdata.ip)
    });
    this.http.get('https://ipapi.co/json').subscribe(res => {
      this.ipDetails = res;
      localStorage.setItem("Timezone", this.ipDetails.timezone);
      localStorage.setItem("Country", this.ipDetails.country_name);
    })
    // this.http.get('https://ipapi.co/json').subscribe(res => {
    this.http.get('https://api.bigdatacloud.net/data/reverse-geocode-client').subscribe(res => {
      this.ipDetails = res;
      localStorage.setItem("Timezone", this.ipDetails.continent);
      localStorage.setItem("Country", this.ipDetails.countryName);
    })
    let ip = localStorage.getItem("ip");
    let login = localStorage.getItem("Lkdgisuvaasdjh");

    // if(login  == undefined || login == null || login == ''){
    //   console.log("log",login);

    //   let data = window.performance.getEntriesByType("navigation")[0]['type'];
    //     if (data == 'navigate') {
    //        this.authService.logout()
    //     }

    // }


  }
  ngOnInit(): void {

    const homebodycls = document.getElementsByTagName('body')[0];
    homebodycls.classList.add('innerbodybg');
    homebodycls.classList.remove('homebodybg');
    homebodycls.classList.remove('TradePage');

    this.ipdata.ip = localStorage.getItem('ip');
    this.theme = sessionStorage.getItem('themes');
    // if (this.theme == "dark-mode") {
    this.themeChange()
    //}
    this.service.commangetfunction('api/v1/site/view').subscribe(response => {
      if (!response.sitemode)
        this.service.SiteFunction(response);
      else
        this.router.navigate(['/under-construction'])
    }, error => {
      console.log(`-----in error-API down--------->`);
      // this.router.navigate(['/under-construction'])
    });

    // localStorage.removeItem("Theme")
    this.service.postfunction('api/v1/verify-ip', { ipaddress: this.ipdata.ip }).subscribe(res => {
      if (res.status) {
        if (res.block && this.ipdata.ip === res.ipaddress) {
          this.block_page = true;
          this.router.navigate(['/404']);
        }
      }
    })

    this.auto_logout();
    this.auto_logout_mobile();
    this.account_block();
    this.ip_block();
    this.metaContent();
    this.siteMaintain();

    // setTimeout(function () {
    //   console.log(localStorage.getItem('Lkdgisuvaasdjh'),"Lkdgisuvaasdjh")
    //   if (localStorage.getItem('Lkdgisuvaasdjh') != null || localStorage.getItem('Lkdgisuvaasdjh') != undefined || localStorage.getItem('Lkdgisuvaasdjh') != '') {
    //     localStorage.clear()
    //     this.router.navigate(['/login'])
    //   }
    // }, 5000)

  }

  themeChange() {
    const body = document.getElementsByTagName('body')[0];
    if (localStorage.getItem('themes') != null) {
      if (localStorage.getItem('themes') == 'dark-mode') {
        localStorage.setItem('themes', 'dark-mode')
        document.body.classList.remove('light-theme');
        document.body.classList.add('dark-mode');
      }
      else {
        localStorage.setItem('themes', 'light-theme')
        document.body.classList.remove('dark-mode');
        document.body.classList.add('light-theme');
      }
    }
    else {
      localStorage.setItem('themes', 'dark-mode')
      document.body.classList.add('dark-mode');
    }
  }
  metaContent(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: 'keywords', content: 'KoinNation, KAIT Coin, KAIT price, Kait Coin INR, Cryptocurrency Exchange, Bitcoin Trading, Buy KAIT, KAIT token, Bitcoin Exchange, Bitcoin Trading, Buy Bitcoin, Digital Asset Exchange' },
      { name: 'description', content: 'Buy, Sell and Trade Bitcoin & other cryptocurrencies on KoinNation. Trade KAIT Coin (KAIT/INR, KAIT/USDT) with live prices and advanced charts.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'KoinNation' },
      { property: 'og:title', content: 'KoinNation - Buy, Sell & Trade Cryptocurrency | KAIT Coin' },
      { property: 'og:description', content: 'Buy, Sell and Trade Bitcoin & other cryptocurrencies on KoinNation. Trade KAIT Coin with live prices and advanced charts.' },
      { property: 'og:url', content: 'https://koinnation.com/' },
      { property: 'og:image', content: 'https://res.cloudinary.com/dzoht037l/image/upload/v1784710635/KAIT-removebg-preview_sygugw.png' },
      { property: 'og:locale', content: 'en_US' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'KoinNation - Buy, Sell & Trade Cryptocurrency | KAIT Coin' },
      { name: 'twitter:description', content: 'Buy, Sell and Trade Bitcoin & other cryptocurrencies on KoinNation. Trade KAIT Coin with live prices and advanced charts.' },
      { name: 'twitter:image', content: 'https://res.cloudinary.com/dzoht037l/image/upload/v1784710635/KAIT-removebg-preview_sygugw.png' },
    ]);
    this.injectJsonLd();
  }

  private injectJsonLd(): void {
    const schemas = [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "KoinNation",
        "url": "https://koinnation.com",
        "logo": "https://res.cloudinary.com/dzoht037l/image/upload/v1784710635/KAIT-removebg-preview_sygugw.png",
        "description": "KoinNation is a leading cryptocurrency exchange platform to buy, sell and trade digital assets including KAIT Coin, Bitcoin, Ethereum and more."
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "KoinNation",
        "url": "https://koinnation.com"
      }
    ];

    schemas.forEach(schema => {
      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', schema['@type']);
      script.text = JSON.stringify(schema);
      this.renderer.appendChild(this.document.head, script);
    });
  }

  siteMaintain(): any {
    this.socket.maintenance().subscribe(res => {
      if (res.status && res.block) {
        this.router.navigate(['/under-construction'])
      }
    });
  }

  account_block(): void {
    this.socket.acc_block().subscribe(res => {
      if (res.status === true && res.block === true && res.token === this.authService.getToken()) {
        this.authService.clearAuthData();
        this.router.navigate(['/']);
      }
    });
  }

  auto_logout(): void {
    this.socket.get_Timeout().subscribe(res => {
      if (res.status === true && res.token === this.authService.getToken()) {
        localStorage.removeItem("Lkdgisuvaasdjh");
        this.router.navigate(['/']);
      }
    });
  }

  auto_logout_mobile(): void {
    this.socket.getMobile_Timeout().subscribe(res => {
      if (res.status === true && res.token === this.authService.getToken()) {
        localStorage.removeItem("Lkdgisuvaasdjh");
        this.router.navigate(['/login']);
      }
    });
  }

  ip_block(): void {
    this.socket.ip_block().subscribe(res => {
      if (res.status === true && res.block === true) {
        if (res.address === this.ipdata.ip) {
          this.toastr.success(res.message);
          this.router.navigate(['/404']);
        }
      }
    });
  }

}
